var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mopage"},[_c('mo_allbuildings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }